// extracted by mini-css-extract-plugin
module.exports = {"root":"_2pw-G","full":"_3To7B"};